import React, { useState } from 'react';
import { Package, Search } from 'lucide-react';
import DataTable from 'components/common/DataTable';
import Pagination from 'components/Pagination';

const ProdutosUsadosPorOSSTable = ({ data = [], loading = false }) => {
  const [busca, setBusca] = useState('');
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Filtrar dados baseado na busca
  const dadosFiltrados = data.filter(item =>
    item.id?.toString().includes(busca.toLowerCase()) ||
    (item.produto && String(item.produto).toLowerCase().includes(busca.toLowerCase())) ||
    (item.assunto && String(item.assunto).toLowerCase().includes(busca.toLowerCase()))
  );

  // Paginação
  const totalPages = Math.ceil(dadosFiltrados.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const dadosPaginados = dadosFiltrados.slice(startIndex, startIndex + itemsPerPage);

  const columns = [
    {
      key: 'id',
      label: 'ID OS',
      sortable: true,
      className: 'w-[12%]',
      render: (value) => (
        <span className="font-medium text-[color:var(--accent)] text-xs">
          {value?.toLocaleString('pt-BR') || 'N/A'}
        </span>
      )
    },
    {
      key: 'assunto',
      label: 'Assunto',
      sortable: true,
      className: 'w-[28%]',
      render: (value) => (
        <span className="font-medium text-[color:var(--text-muted)] text-xs truncate block" title={value}>
          {value || 'N/A'}
        </span>
      )
    },
    {
      key: 'produto',
      label: 'Quantidade de produtos utilizados',
      sortable: true,
      className: 'w-[40%]',
      render: (value) => (
        <span className="font-medium text-[color:var(--text-primary)] text-xs truncate block" title={value}>
          {value || 'N/A'}
        </span>
      )
    },
    {
      key: 'custo',
      label: 'Custo',
      sortable: true,
      className: 'w-[20%]',
      render: (value) => (
        <span className="font-bold text-[color:var(--status-good)] text-xs">
          R$ {Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
        </span>
      )
    }
  ];

  return (
    <div className="bg-[color:var(--surface)] rounded-lg shadow-sm border">
      {/* Header */}
      <div className="px-6 py-4 border-b border-[color:var(--border)]">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Package className="w-5 h-5 text-[color:var(--accent)] mr-2" />
            <h3 className="text-lg font-semibold text-[color:var(--text-primary)]">
              Produtos Usados por OSS
            </h3>
          </div>
          <div className="text-sm text-[color:var(--text-muted)]">
            {dadosFiltrados.length} {dadosFiltrados.length === 1 ? 'item' : 'itens'}
          </div>
        </div>
      </div>

      {/* Busca */}
      <div className="px-6 py-4 border-b border-[color:var(--border)]">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-[color:var(--text-muted)]" />
          </div>
          <input
            type="text"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            className="block w-full pl-10 pr-3 py-2 border border-[color:var(--border)] rounded-md leading-5 bg-[color:var(--surface)] text-[color:var(--text-primary)] placeholder-[color:var(--text-muted)] focus:outline-none focus:ring-1 focus:ring-[color:var(--accent)] focus:border-[color:var(--accent)]"
            placeholder="Buscar por ID OS, produto ou assunto..."
          />
        </div>
      </div>

      {/* Tabela */}
      <div className="px-6 py-4">
        <DataTable
          data={dadosPaginados}
          columns={columns}
          loading={loading}
          maxHeight="max-h-96"
          emptyMessage="Nenhum produto encontrado"
        />
      </div>

      {/* Paginação */}
      {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-[color:var(--border)]">
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={setItemsPerPage}
            totalItems={dadosFiltrados.length}
          />
        </div>
      )}

      {/* Resumo */}
      {dadosFiltrados.length > 0 && (
        <div className="px-6 py-4 bg-[color:var(--surface-muted)] border-t border-[color:var(--border)]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="text-center">
              <p className="text-sm font-medium text-[color:var(--text-muted)]">Total de OSS</p>
              <p className="text-lg font-semibold text-[color:var(--text-primary)]">
                {dadosFiltrados.length}
              </p>
            </div>
            <div className="text-center">
              <p className="text-sm font-medium text-[color:var(--text-muted)]">Custo Total</p>
              <p className="text-lg font-semibold text-[color:var(--status-good)]">
                R$ {dadosFiltrados.reduce((total, item) => total + (Number(item.custo) || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </p>
            </div>
            <div className="text-center">
              <p className="text-sm font-medium text-[color:var(--text-muted)]">Custo Médio</p>
              <p className="text-lg font-semibold text-[color:var(--accent)]">
                R$ {(dadosFiltrados.reduce((total, item) => total + (Number(item.custo) || 0), 0) / dadosFiltrados.length).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProdutosUsadosPorOSSTable;


